import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { useLocation, useNavigate } from 'react-router-dom';

export default function OrderDetails() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");

    const [orderData, setOrderData] = useState([]);
    const [baby_profile, setBabyProfile] = useState([]);
    const [user_data, setUserData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";

            try {
                const apiToken = sessionStorage.getItem("api_token");

                if (!apiToken) {
                    console.error("API Token not found in session storage");
                    return;
                }

                const response = await fetch(`${apiUrl}/order-details`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams({
                        su_id: 1,
                        api_token: apiToken,
                        trans_from: "SUPER_ADMIN",
                        order_id: id,
                    }),
                });

                if (response.ok) {
                    const data = await response.json();
                    setOrderData(data.data);
                    setBabyProfile(data.data.baby_profile);
                    setUserData(data.data.user_data);
                    console.log(data.data)
                } else {
                    console.error("Failed to fetch data");
                }
            } catch (error) {
                console.error("Error occurred while fetching data", error);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <div id="wrapper">
                <Sidebar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div className="container-fluid">
                            <h1 className="h3 mb-4 text-gray-800">Order Details</h1>
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-3">
                                            Order Details
                                        </div>
                                        <div className="col-md-5">
                                            Order Number : {orderData.order_number}
                                        </div>
                                        <div className="col-md-4">
                                            Order Status : {orderData.status}
                                        </div>
                                    </div>

                                </div>
                                <div className="card-body" style={{ background: "#fff", padding: "20px", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                                    <h4 style={{ marginBottom: "20px", color: "#4e73df", borderBottom: "2px solid #4e73df", paddingBottom: "10px" }}>User & Baby Information</h4>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Parent Name:</strong> {user_data.name}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Baby Name:</strong> {baby_profile.name}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Age:</strong> {baby_profile.age}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Contact:</strong> {baby_profile.contact_number}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>DOB:</strong> {baby_profile.date_of_birth}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Disability:</strong> {baby_profile.disabilities}
                                        </div>
                                    </div>

                                    <h4 style={{ marginBottom: "20px", color: "#4e73df", borderBottom: "2px solid #4e73df", paddingBottom: "10px" }}>Order & Address Information</h4>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>City:</strong> {orderData.city}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Pin Code:</strong> {orderData.pincode}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Street:</strong> {orderData.area_street}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>House No:</strong> {orderData.house_no}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Landmark:</strong> {orderData.landmark}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Doctor Information:</strong> {baby_profile.doctor_information}
                                        </div>
                                    </div>

                                    <h4 style={{ marginBottom: "20px", color: "#4e73df", borderBottom: "2px solid #4e73df", paddingBottom: "10px" }}>Service Details</h4>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Created Date:</strong> {orderData.created_date}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Start Date:</strong> {orderData.start_date}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <strong>Time:</strong> {orderData.service_start_timing}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Rate:</strong> {orderData.rate}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>

        </>
    )
}
